import {isDevMode, Pipe, PipeTransform} from "@angular/core";
import {ValidationErrors} from "@angular/forms";
import {i18n, Oversettelser} from "../tjenester/i18n/Oversettelser";
import {erNil} from "felles-ng2/støttefunksjoner/nilsjekk";
import {PlainDateDateAdapter} from "felles-ng2/infrastruktur/material/PlainDateDateAdapter";

/** Pipe som produserer tekst for vanlige valideringsfeil. */
@Pipe({name: 'standardvalideringsfeil', pure: true, standalone: true})
export class StandardValideringsfeilPipe implements PipeTransform {

    constructor(private oversettelser: Oversettelser, private matDatoAdapter: PlainDateDateAdapter) {
    }

    transform(feil: ValidationErrors | null, feilnøkkel: 'maxlength'|'matDatepickerParse'): string {
        if (erNil(feil)) return '';
        switch (feilnøkkel){
            case 'maxlength': return this.oversettelser.oversett(i18n('Maks {maks} tegn, du må fjerne {overskytende} tegn'), {maks: feil.maxlength.requiredLength, overskytende: feil.maxlength.actualLength - feil.maxlength.requiredLength});
            case 'matDatepickerParse': return this.oversettelser.oversett(i18n('Ugyldig datoformat, forventet {format}'), {format: this.matDatoAdapter.localeSensitivtParseFormat().toLowerCase()});
            default:
                if (isDevMode()) throw new Error(`Ukjent feilnøkkel-argument '${feilnøkkel}' i standardvalideringsfeil pipe`);
                return '';
        }
    }
}

